export enum RecipientAction {
    ViewMedicalDetails = 1,
    Edit = 2,
    Divider = -1
}